var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"card-plain"},[_c('p',{staticClass:"gdpr-text pr-4 pl-4"},[_vm._v(_vm._s(_vm.$t('GDPR Info')))])])}
var staticRenderFns = []

export { render, staticRenderFns }